module.exports = __webpack_public_path__ + "static/img/chong_tu.4f59df9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/chong_tu.png
// module id = W8CS
// module chunks = 2